import { render, staticRenderFns } from "./ds-chart-panel.vue?vue&type=template&id=9ea279ac&scoped=true"
import script from "./ds-chart-panel.vue?vue&type=script&lang=js"
export * from "./ds-chart-panel.vue?vue&type=script&lang=js"
import style0 from "./ds-chart-panel.vue?vue&type=style&index=0&id=9ea279ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea279ac",
  null
  
)

export default component.exports